import React, { useEffect, useRef, useState } from 'react'
import { ITeam } from 'screens/Protection/protection.types'
import useDnD from 'shared/hooks/useDnD'
import css from './Cell.module.css'
import Button from 'shared/Buttons/Button/Button'

interface IProps {
  team: ITeam | null
  rowIndex: number
  roomIndex: number
  onOpenModal: () => void
  moveTeam: (fromRow: number, fromRoom: number, toRow: number, toRoom: number) => void
  onDelete: () => void
}

const Cell = ({ team, rowIndex, roomIndex, onOpenModal, moveTeam, onDelete }: IProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [menu, setMenu] = useState<{
    x: number
    y: number
  } | null>(null)

  const dnd = useDnD({
    id: `${rowIndex}-${roomIndex}`,
    prefix: 'team-slot-',
    ref,
    style: {
      background: '#f3f4f6',
    },
    onDrop: (draggedId) => {
      const [fromRow, fromRoom] = draggedId.split('-').map(Number)

      moveTeam(fromRow, fromRoom, rowIndex, roomIndex)
    },
  })

  useEffect(() => {
    const close = () => setMenu(null)

    window.addEventListener('click', close)

    return () => window.removeEventListener('click', close)
  }, [])

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault()

    setMenu({
      x: e.clientX,
      y: e.clientY,
    })
  }

  return (
    <div
      ref={ref}
      className={css.cell}
      onDragOver={dnd.onDragOver}
      onDragEnter={dnd.onDragEnter}
      onDragLeave={dnd.onDragLeave}
      onDrop={dnd.onDrop}
    >
      {team ? (
        <>
          <div
            draggable
            className={css.teamCard}
            onDragStart={dnd.onDragStart}
            onDragEnd={dnd.onDragEnd}
            onContextMenu={handleContextMenu}
          >
            <p className={css.teamName}>{team.name}</p>
          </div>

          {menu && (
            <div
              className={css.contextMenu}
              style={{
                top: menu.y,
                left: menu.x,
              }}
            >
              <Button
                className={css.contextMenuItem}
                theme='danger'
                onClick={() => {
                  onDelete()
                  setMenu(null)
                }}
              >
                Удалить команду
              </Button>
            </div>
          )}
        </>
      ) : (
        <button className={css.addInsideBtn} onClick={onOpenModal}>
          +
        </button>
      )}
    </div>
  )
}

export default Cell
